import { Controller, useFormContext } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import styles from "./DefaultPhoneInputField.module.scss";
import { classNames } from "primereact/utils";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { SkeletonItem } from "../../../skeletons/SkeletonItem";
import { useAppContext } from "../../../../../AppContext";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface IDefaultPhoneInputFieldProps {
  name: string;
  label: string;
  required?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  defaultCountry?: string;
  className?: string;
  width?: string;
}

export const DefaultPhoneInputField = ({
  name,
  label,
  required = false,
  isLoading = false,
  disabled = false,
  defaultCountry = "bg",
  className,
  width,
}: IDefaultPhoneInputFieldProps) => {
  const { control } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div style={{ width: width, maxWidth: width }} className={className}>
          <RenderWhen condition={!!label}>
            <div
              className={classNames(styles.phoneInput_label, {
                [styles.phoneInput_label_error]: !!fieldState.error?.message,
              })}
            >
              {label}
              {required ? "*" : ""}
            </div>
          </RenderWhen>

          <SkeletonItem
            className={styles.root_input_skeleton}
            isLoading={isLoading}
            value={
              <PhoneInput
                country={defaultCountry}
                searchPlaceholder="Търси държава"
                value={field.value}
                onChange={field.onChange}
                inputProps={{
                  disabled,
                  name: field.name,
                  className: classNames(styles.root_input, {
                    [styles.root_input_error]: fieldState.error,
                  }),
                }}
                containerClass={styles.phoneInput}
                inputStyle={{ maxWidth: width }}
                containerStyle={{ maxWidth: width }}
                enableSearch
              />
            }
          />
        </div>
      )}
    />
  );
};
